let environment = process.env.REACT_APP_ENVIRONMENT;

let backendPath = '/api/';

const AppConfig = {
  backendPath: backendPath,
  oauthConnectionsPath: backendPath + 'oauth2/authorization/xero',
  oauthLoginPath: backendPath + 'oauth2/authorization/xero-login',
  oauthSignupPath: backendPath + 'oauth2/authorization/xero-signup',
  oauthXpmPath: backendPath + 'oauth2/authorization/xero-xpm',
  logoutPath: backendPath + 'logout',
  xeroOrganisationPath: 'https://go.xero.com/organisationlogin/default.aspx?shortcode=',
  isLocal: environment === 'local',
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
};

export default AppConfig;
